import { PaymentMethodOption } from 'action/components/payment-method-selection/payment-method-selection';
import { PaymentAttribution } from 'core/enums/payment-type';
import { PaymentRequestRedirectResponse } from 'core/services/api/payment/payment-dpp';
import { NumberUtils } from 'utils/number.utils';
import { PaymentRequestType } from './payment-request';

const PayAtPaymentOptions = new Map<string, any>([
  ['CARD', {
    value: 'CARD',
    icon: 'icon-credit-card_64',
    description: 'account.paymentMethod.creditCard',
  }],
  ['TEST_WEB_CLFPcbPPjR', {
    value: 'TEST_WEB_CLFPcbPPjR',
    icon: 'icon-help',
    description: 'account.paymentMethod.bank',
  }],
  ['TEST_WEB', {
    value: 'TEST_WEB',
    icon: 'icon-help',
    description: 'account.paymentMethod.test',
  }],
  ['CAPITEC_EFT', {
    value: 'CAPITEC_EFT',
    icon: 'icon-imi-accounts',
    description: 'account.paymentMethod.capitecEft',
  }],
  ['EFT', {
    value: 'EFT',
    icon: 'icon-imi-accounts',
    description: 'account.paymentMethod.eft',
  }],
]);

export interface PayAtRedirectResponse {
  paymentMethodName: "CARD" | "CAPITEC_EFT" | "TEST_WEB_ovQfHewrjy" | "TEST_WEB_CLFPcbPPjR" | "EFT" | string;
  paymentUrl: string;
}

export interface PayAtRedirectResolution {
  paymentOptions: PaymentMethodOption[]
}

export class PaymentRequestPayAt implements PaymentRequestType<PayAtRedirectResponse[]> {
  constructor(private request: any) { }

  addValues(values: { [key: string]: number | string | undefined }) {
    this.request = {
      ...this.request,
      ...values
    }
    return this;
  }

  getDependantValues() {
    return Promise.resolve(this);
  }

  toPaymentRequestObject() {
    const { customerNumber, amount, successReturnUrl, failureReturnUrl, location, paymentAttribution } = this.request;
    const amountNumber = +`${amount}`;
    const amountInCents = isNaN(amountNumber) ? 0 : NumberUtils.FormatToDecimal(amountNumber * 100, '0-0', '');
    return {
      messageId: crypto.randomUUID(),
      accountNumber: customerNumber,
      amount: `${amountInCents}`,
      clientReference: customerNumber,
      successUrl: successReturnUrl,
      failedUrl: failureReturnUrl,
      cancelledUrl: location,
      qrTags: [`jid=${paymentAttribution}`],
    };
  }

  toTokenRequestObject() {
    const { customerNumber, amount, accountNumber, location, paymentMetaData } = this.request;
    const amountNumber = +`${amount}`;
    const amountInCents = isNaN(amountNumber) ? 0 : NumberUtils.FormatToDecimal(amountNumber * 100, '0-0', '');
    const { paymentAttribution } = paymentMetaData;

    return {
      accountNumber: customerNumber,
      amount: `${amountInCents}`,
      customerId: customerNumber,
      customerRedirectUrl: location,
      clientReference: `${accountNumber}-${customerNumber}-ZA`,
      qrTags: [`jid=${paymentAttribution}`],
    };
  }

  handleResponse(response: PayAtRedirectResponse[] | PaymentRequestRedirectResponse): Promise<PayAtRedirectResolution | boolean> {
    // TODO: improve conditional type logic
    if (Object.prototype.hasOwnProperty?.call(response, 'redirectUrl')) {
      const res = response as PaymentRequestRedirectResponse;
      // sessionStorage.setItem('dstv-ss.tid', `${res.transactionId}:${res.paymentType}`);
      window.location.assign(res.redirectUrl);
      return Promise.resolve(false)
    }

    const res = response as PayAtRedirectResponse[];
    return Promise.resolve({
      paymentOptions: res.map(item => {
        if (PayAtPaymentOptions.has(item.paymentMethodName)) {
          return {
            ...PayAtPaymentOptions.get(item.paymentMethodName),
            data: item.paymentUrl
          }
        }
      }).filter(item => item !== undefined)
    });
  }
}